<template>
    <!-- // detalhes de uso do storage -->
    <div>
        <div id="modalStorageDetails" class="modal inmodal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" class="top-img">
                            <g transform="translate(-1754 -341)">
                            <g transform="translate(5539 6543)">
                            <circle class="svg--extra-lighten" cx="33" cy="33" r="33" transform="translate(-3785 -6202)" fill="#afd7ff"/>
                            <g transform="translate(-3768 -6186)">
                            <path class="svg--primary" d="M29,20H3a1,1,0,0,1-.89-1.45l5-10A1,1,0,0,1,8,8H24a1,1,0,0,1,.89.55l5,10A1,1,0,0,1,29,20ZM4.62,18H27.38l-4-8H8.62Z" fill="#0080fc"/>
                            <path class="svg--primary" d="M29,18H3a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V19A1,1,0,0,0,29,18Zm-4,5H24a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z" fill="#0080fc"/>
                            <path class="svg--primary" d="M21,16H11a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z" fill="#0080fc"/>
                            </g>
                            </g>
                            </g>
                        </svg>
                        <h4 class="modal-title title" v-text="this.t.title"></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th v-text="this.t.label_application"></th>
                                    <th v-text="this.t.label_in_use"></th>
                                    <th v-text="this.t.label_percent"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr :class="(detail.is_total == true) ? 'total':''" v-for="(detail,i) in this.details" :key="i">
                                    <td v-html="detail.app"></td>
                                    <td v-text="detail.use + ' Mb'"></td>
                                    <td v-text="detail.percent + '%'"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <button class="button3"  v-text="t.label_fechar" @click="close()"></button>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import qs from 'qs';

    export default {
        name: "storage-details",
        props: [
            'translations', 'details'
        ],
        data() {
            return {
                t : this.translations
            }
        },

        methods: {
          close : function(){
              $('#modalStorageDetails').modal('hide')
          }  
        }
    };

</script>

<style scoped lang="scss">
    $blue: var(--theme-color-primary);;
    $red:#F54B5E;
    
    th{
        text-align: center;
        @media only screen and (max-width: 600px) {
            font-size: 0.8rem;
        }
    }

    td{
        text-align: center;
        padding-top: 10px !important;
        padding-bottom: 5px !important;
         @media only screen and (max-width: 600px) {
            font-size: 0.8rem;
        }
    }

    .button3{
        float: right;
        margin-top: 30px;
        margin-right: 10px;
    }

    .modal{
        top: 10%;
        @media only screen and (max-width: 600px) {
            top: 0;
        }
    }

    .total{
        font-weight: bold;
    }

    .modal-header{
        padding-bottom: 5px;
    }

    .modal-title{
        padding-top: 10px;
    }
    
    /* modal scroll */
    .modal-dialog{
        overflow-y: initial !important
    }
    .modal-body{
        height: auto;
        overflow-y: auto;
    }

</style>


// WEBPACK FOOTER //
// resources/office/js/components/domains-storage/storageDetails.vue